import React from 'react';
import { Box, H5, Copy, Optional, Icon } from '@honda-canada/design-system-react';
import styled from 'styled-components';
import themeStyles from './DealerDetailsCard.styles';
import RoutableSitecoreLink from '../../../../../RoutableSitecoreLink';
const Container = themeStyles.apply(Box, 'Container');
const Title = themeStyles.apply(H5, 'Title');
const Text = themeStyles.apply(Copy, 'Text');
const IconsWrapper = themeStyles.apply(Box, 'IconsWrapper');
const IconWrapper = themeStyles.apply(Box, 'IconWrapper');
const IconLabel = themeStyles.apply(Copy, 'IconLabel');
const CenteredItem = themeStyles.apply(Box, 'CenteredItem');
const Link = styled(RoutableSitecoreLink)(themeStyles.get('ActionLink'));
const DealerDetailsCard = ({ dealer, testId }) => {
    var _a, _b;
    if (!dealer)
        return null;
    const { dealerCode, dealerOperatingName, address: { streetAddressLineOne, city }, contact: { primaryPhone, email, website }, } = dealer;
    const operatingHours = (_b = (_a = dealer.departments[0]) === null || _a === void 0 ? void 0 : _a.hours) === null || _b === void 0 ? void 0 : _b[0];
    const formattedWebsite = (website === null || website === void 0 ? void 0 : website.startsWith('http')) ? website : `https://${website}`;
    const contactItems = [
        { value: primaryPhone, icon: 'phone' },
        { value: email, icon: 'email' },
        {
            value: website,
            icon: 'home',
            link: !website ? null : formattedWebsite,
        },
    ];
    return (React.createElement(Container, { "data-testid": testId || 'cy-InventoryModal-dealer_details_card', id: `dealer_details_card_${dealerCode}` },
        React.createElement(Title, { "data-testid": "cy-InventoryModal-dealer_details_card-title" }, dealerOperatingName),
        React.createElement(Text, { "data-testid": "cy-InventoryModal-dealer_details_card-address" },
            streetAddressLineOne,
            ", ",
            city),
        React.createElement(Optional, { when: (operatingHours === null || operatingHours === void 0 ? void 0 : operatingHours.start) && operatingHours.end },
            React.createElement(Text, { "data-testid": "cy-InventoryModal-dealer_details_card-hours" }, `Hours: ${operatingHours === null || operatingHours === void 0 ? void 0 : operatingHours.start} - ${operatingHours === null || operatingHours === void 0 ? void 0 : operatingHours.end}`)),
        React.createElement(IconsWrapper, null, contactItems.map(({ value, icon, link }) => (React.createElement(Optional, { key: icon, when: value },
            React.createElement(IconWrapper, { key: icon },
                React.createElement(CenteredItem, { "data-testid": `cy-InventoryModal-dealer_details_card-${icon}-icon` },
                    React.createElement(Icon, { iconColor: "red", name: icon })),
                React.createElement(IconLabel, { "data-testid": `cy-InventoryModal-dealer_details_card-${icon}-label` }, value),
                React.createElement(Optional, { when: link },
                    React.createElement(CenteredItem, null,
                        React.createElement(Link, { "data-testid": "cy-InventoryModal-dealer_details_card-external_link-icon", styling: "secondary", field: {
                                value: {
                                    linktype: 'external',
                                    href: link,
                                    target: '_blank',
                                },
                            } },
                            React.createElement(CenteredItem, { height: "15px" },
                                React.createElement(Icon, { name: "externalLink" }))))))))))));
};
export default DealerDetailsCard;
